import React, { useEffect, useState, useMemo } from 'react';
import { Tabs, Popover, Tooltip, Row, Col } from 'antd';
import { ReactComponent as InfoIcon } from 'assets/icons/info_icon.svg';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useSelector, useDispatch } from 'react-redux';
import ApplicationStatusOverview from 'components/applicationStatusOverview';
import { ReactComponent as ViewTaskLink } from '../../assets/icons/view_task_link.gov.svg';
import { useNavigate } from 'react-router-dom';
import { claimActiveViewMode, updateFormField } from 'store/forms/actions';

const { TabPane } = Tabs;

const CustomTabsTimeline = ({
  tabs = [],
  tabProps,
  customClass,
  current,
  setCurrent,
  activeTask,
  isApptrack,
  ...rest
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locales = useSelector(state => state.forms?.localeStrings);
  const activeFormId = useSelector(state => state.activeForm.activeFormId);

  // Safe initial index: 0 if current is not a finite number
  const initialIndex = useMemo(
    () => (Number.isFinite(current) ? Number(current) : 0),
    [current]
  );

  const [activeTab, setActiveTab] = useState(initialIndex);

  const onViewMode = id => {
    dispatch(claimActiveViewMode(navigate, id));
  };

  const onChange = key => {
    const idx = Number(key); // antd passes string keys
    setActiveTab(idx);
    if (typeof setCurrent === 'function') setCurrent(idx);
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'currentSubTab',
        value: null,
      })
    );
  };

  // Keep internal state in sync when parent changes `current`
  useEffect(() => {
    if (Number.isFinite(current)) setActiveTab(Number(current));
  }, [current]);

  // If there are no tabs, avoid rendering Tabs entirely
  if (!tabs.length) return null;

  return (
    <div className={`${customClass || ''}`}>
      <Tabs
        // Controlled component: only use activeKey (drop defaultActiveKey)
        activeKey={String(activeTab)}
        onChange={onChange}
        {...rest}
      >
        {tabs.map(({ name, label, Component }, index) => (
          <TabPane
            key={String(index)} // ✅ keys must be strings
            tab={
              <div className="tab-timeline">
                <div className="ml-1 tab-timeline-index">
                  {activeTab > index ? (
                    <Check
                      className="tab-timeline-check"
                      width="14px"
                      height="14px"
                    />
                  ) : (
                    index + 1
                  )}
                </div>
                <div className="tab-timeline-label">
                  {name === 'AREAFORM'
                    ? 'Περιοχή Δραστηριότητας'
                    : name === 'BASICFORM'
                    ? 'Στοιχεία Αίτησης'
                    : name === 'DOCUMENTS'
                    ? 'Έγγραφα'
                    : name === 'TERMS'
                    ? 'Όροι & Προϋποθέσεις'
                    : name === 'GRAPH'
                    ? 'Συνοπτική Παρουσίαση Κατάστασης Αίτησης'
                    : name === 'INFO'
                    ? 'Στοιχεία Αίτησης'
                    : name === 'BUSINESSPLAN'
                    ? 'Το Επιχειρηματικό μου Σχέδιο'
                    : name === 'BANK'
                    ? 'Πιστωτικό Ίδρυμα'
                    : getLocalString(
                        locales,
                        localNames.REQUEST_PAGE_HISTORICITY
                      )}
                </div>
                {index === tabs.length - 1 ? '' : <div className="divider" />}
              </div>
            }
          >
            {isApptrack && (
              <Row>
                <Col span={12}>
                  <ApplicationStatusOverview
                    // id={activeTask?.businessKey}
                    // activeTaskName={activeTask?.activeTaskName}
                    id="10000"
                    activeTaskName="Βαγγέλης"
                  />
                </Col>
                <Col span={12}>
                  {activeTab === 1 && (
                    <div
                      className="tab2-icons"
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginRight: '2rem',
                        marginTop: '3.25rem',
                      }}
                    >
                      <Tooltip
                        placement="left"
                        title="Δείτε τα αναλυτικά στοιχεία της αίτησης"
                      >
                        <ViewTaskLink
                          style={{ cursor: 'pointer' }}
                          onClick={() => onViewMode(activeFormId)}
                        />
                      </Tooltip>
                    </div>
                  )}
                </Col>
              </Row>
            )}
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimeline;
